import {resource} from '@albert-io/json-api-framework/request/builder';

export default function baseAssignmentsQuery(studentId: string, classroomId?: string) {
  return resource('assignments_v3')
    .mandarkEndpoint(['students_v2', studentId, 'assignments_v3'])
    .filter(
      {
        classrooms_v1: classroomId
      },
      classroomId !== undefined
    )
    .pageSize(15);
}
